module.exports = __webpack_public_path__ + "static/media/candy-corn.f5406b44.svg";